import { FC } from 'react'
import { styled } from '@portfolio/styles'
import { SectionWrapper } from '@portfolio/components'
import { SectionTextBlocksProps } from '@portfolio/models'

const StyledSectionWrapper = styled(SectionWrapper, {
  padding: '$96 0',
  backgroundColor: '$darkThemeBackground',
  color: '$white',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  gap: '$96',
  containerSpace: 'medium',

  '@md': {
    gap: '$120',
  },
})

const Title = styled('h2', {
  projectFont: 'heading04',
  textAlign: 'center',
})

const TextBlocksWrap = styled('div', {
  display: 'grid',
  gap: '$96',

  '@md': {
    maxWidth: '$aboutPageContentWidth',
    gridTemplateColumns: '1fr 1fr',
    justifyItems: 'center',
    columnGap: '$96',
    rowGap: '$textBlocksRowGap',
  },
})

const BlockTitle = styled('h3', {
  projectFont: 'heading07',
  marginBottom: '$24',
})

const BlockText = styled('p', {
  projectFont: 'body03',
  color: '$white_06',
})

export const SectionTextBlocks: FC<SectionTextBlocksProps> = ({
  title,
  textBlocks,
}) => {
  return (
    <StyledSectionWrapper type="NO_MARGIN">
      {title && <Title>{title}</Title>}
      <TextBlocksWrap>
        {textBlocks &&
          textBlocks?.length > 0 &&
          textBlocks.map((textBlock, index) => (
            <div key={`${textBlock.title}-${index}`}>
              {textBlock.title && <BlockTitle>{textBlock.title}</BlockTitle>}
              {textBlock.text && <BlockText>{textBlock.text}</BlockText>}
            </div>
          ))}
      </TextBlocksWrap>
    </StyledSectionWrapper>
  )
}
